export default "__VITE_ASSET__88514c46__"